import { z } from 'zod'

export const schema = z.object({
  timezone: z.string(),
})
export type FormValues = z.infer<typeof schema>
